import { Button } from '@/common/ui/Form/Button'
import { TableScrollHost, Table, Tbody, Td, Th, Thead, Tr } from '@/common/ui/Table/Table'
import { Icon } from '@/common/ui/Icon'
import { cn } from '@/common/lib/cn/cn'
import { Modal } from '@/common/ui/Modal'
import { useOrgInvitations, useRevokeInvitation } from '../models'
import type { MembershipRole } from '@/common/api/client/types.gen'
import { AddOrgInvitationForm } from './AddOrgInvitationForm'
import { useState } from 'react'
import { useToast } from '@/common/ui/Toast/toastContext'

const roleMap: Record<MembershipRole, string> = {
    owner: 'Владелец',
    admin: 'Администратор',
    manager: 'Менеджер',
    member: 'Участник',
    viewer: 'Просмотрщик',
}

export const OrgInvitationsTable = ({ className }: { className?: string }) => {
    const { orgInvitations, currentOrg, isLoading, error } = useOrgInvitations()

    const { mutate: removekeInvitation } = useRevokeInvitation()
    const [invitationToDelete, setInvitationToDelete] = useState<string | null>(null)
    const toastContext = useToast()

    const handleDeleteClick = (invitationId: string) => {
        setInvitationToDelete(invitationId)
        const checkbox = document.getElementById('confirm-delete-invitation-modal') as HTMLInputElement

        if (checkbox) {
            checkbox.checked = true
        }
    }

    const handleConfirmDelete = () => {
        if (invitationToDelete) {
            removekeInvitation(invitationToDelete)
            setInvitationToDelete(null)
            toastContext?.showToast({ type: 'success', message: 'Приглашение удалено' })
            const checkbox = document.getElementById('confirm-delete-invitation-modal') as HTMLInputElement

            if (checkbox) {
                checkbox.checked = false
            }
        }
    }

    const handleCancelDelete = () => {
        setInvitationToDelete(null)
        const checkbox = document.getElementById('confirm-delete-invitation-modal') as HTMLInputElement

        if (checkbox) {
            checkbox.checked = false
        }
    }

    if (isLoading) return <div>Loading...</div>
    if (error) return <div>Error: {error.message}</div>

    if (!currentOrg) {
        return
    }
    console.log('orgInvitations', orgInvitations)

    return (
        <>
            {orgInvitations && orgInvitations.length > 0 && (
                <div className='grid-cols-2 mt-6'>
                    <h3 className='text-lg font-medium mb-2'>Приглашения</h3>
                </div>
            )}
            <TableScrollHost className={cn('grid-cols-2', className)} minHeight={false} outline={false}>
                {orgInvitations && orgInvitations.length > 0 && (
                    <Table border pinRows pinCols striped thBg>
                        <Thead>
                            <Tr>
                                <Th>Имя Фамилия</Th>
                                <Th>Роль</Th>
                                <Th>Email</Th>
                                <Th>Статус</Th>
                                <Th>Действия</Th>
                            </Tr>
                        </Thead>

                        <Tbody>
                            {orgInvitations.map((invitation, index) => (
                                <Tr key={index}>
                                    <Td>
                                        <>{/* {invitation?.first_name} {invitation?.last_name} */}</>
                                    </Td>
                                    <Td>{roleMap[invitation.role]}</Td>
                                    <Td>{invitation?.email}</Td>
                                    <Td>{invitation?.user_exists ? 'Зарегистрирован' : 'Незарегистрирован'}</Td>
                                    <Td className='text-center'>
                                        {invitation.role !== 'owner' && (
                                            <Button
                                                emphasis='neutral'
                                                variant='ghost'
                                                size='lg'
                                                onClick={() => handleDeleteClick(invitation.id)}
                                            >
                                                <Icon name='trash' size='sm' />
                                            </Button>
                                        )}
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                )}
            </TableScrollHost>

            <div className='grid-col-1'>
                <Button as='label' htmlFor='addOrgInvitationModal' emphasis='secondary' variant='ghost' size='lg'>
                    <Icon name='plus' size='md' />
                    Пригласить участника
                </Button>
            </div>

            <Modal id='addOrgInvitationModal'>
                <h3 className='text-lg font-bold'>Пригласить участника</h3>
                <AddOrgInvitationForm />
            </Modal>

            <Modal id='confirm-delete-invitation-modal'>
                <h3>Подтверждение удаления</h3>
                <p>Вы уверены, что хотите удалить это приглашение?</p>
                <p>Это действие нельзя будет отменить.</p>

                <div className='modal-form-actions mt-5'>
                    <Button size='xl' emphasis='negative' variant='filled' onClick={handleConfirmDelete}>
                        Удалить
                    </Button>
                    <Button size='lg' emphasis='secondary' variant='ghost' onClick={handleCancelDelete}>
                        Отмена
                    </Button>
                </div>
            </Modal>
        </>
    )
}
